<template>
  <div v-if="crew">
    <v-layout>
      <v-main>
        <v-container class="">
          <v-card>
            <v-row>
              <v-col cols="8" sm="2">
                <v-sheet class="ma-2 pa-0">
                  <v-img :width="300" cover @error="onImgError" :src="profileImageLink"
                    :lazy-src="profileImageThumbLink"></v-img>
                </v-sheet>
              </v-col>
              <v-col cols="28" sm="10">
                <v-sheet class="ma-2 pa-2">
                  <div class="pa-2 text-h3">{{ catData.name }}</div>
                </v-sheet>
                <v-sheet class="ma-2 pa-2 text-h6">
                  <v-container>
                    <v-row>
                      <v-col>
                        Geburtstag:
                      </v-col>
                      <v-col>
                        {{ catData.birthday.getUTCDate() }}. {{ catData.birthday.toLocaleString('default', {
                          month: 'long'
                        }) }} {{ catData.birthday.getUTCFullYear() }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        Farbe:
                      </v-col>
                      <v-col>
                        {{ catData.color }} ({{ catData.colorcode }})
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        Gesundheitsdaten:
                      </v-col>
                      <v-col>
                        <div v-show="health.value" v-for="health in catData.healthdata" :key="'health_' + health.id">
                          {{ health.title }}: {{ health.value }}
                        </div>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        Genteste:
                      </v-col>
                      <v-col>
                        <div v-show="catData.genteste.length" v-for="gentest in catData.genteste"
                          :key="'gentest_' + gentest[0]">
                          {{ gentest[0] }} {{ gentest[1] }}
                        </div>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-btn :href="catData.pawpedslink" rel="noopener noreferrer" target="_blank">
                          Stammbaum
                        </v-btn>
                      </v-col>
                      <v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-main>
    </v-layout>
  </div>
  <div v-else>
    <crew-view></crew-view>
  </div>
</template>

<script>
import { useWuerfeStore } from "../store/wuerfe"
import CrewView from "./CrewView.vue"

export default {
  components: {
    CrewView,
  },
  setup() {
    const wuerfeStore = useWuerfeStore();
    return { wuerfeStore };
  },
  computed: {
    profileImageThumbLink() {
      if (this.crew && !this.failedImage) {
        if (process.env.NODE_ENV === 'development') {
          return require("@/assets/static/katzendetails/thumb." + this.crew + ".png");
        } else {
          return "https://static.jokingheroes.de/katzendetails/thumb." + this.crew + ".png";
        }
      } else {
        if (process.env.NODE_ENV === 'development') {
          return require("@/assets/static/katzendetails/keinbild.png");
        } else {
          return "https://static.jokingheroes.de/katzendetails/keinbild.png";
        }
      }
    },
    profileImageLink() {
      if (this.crew && !this.failedImage) {
        if (process.env.NODE_ENV === 'development') {
          return require("@/assets/static/katzendetails/" + this.crew + ".png");
        } else {
          return "https://static.jokingheroes.de/katzendetails/" + this.crew + ".png";
        }
      } else {
        if (process.env.NODE_ENV === 'development') {
          return require("@/assets/static/katzendetails/keinbild.png");
        } else {
          return "https://static.jokingheroes.de/katzendetails/keinbild.png";
        }
      }
    },
  },
  created() {
    this.updateCrewData();
  },
  beforeUpdate() {
    this.updateCrewData();
  },
  methods: {
    onImgError: function (event) {
      console.log("Caught image error", event);
      this.failedImage = true;
    },
    updateCrewData() {
      if (this.crew) {
        let catsData = this.wuerfeStore.cats;
        this.catData = catsData[this.crew];
      }
    },
  },
  props: [
    'crew',
  ],
  data: () => ({
    catData: {},
    failedImage: false,
  }),
}
</script>

<style scoped>
.slightlyPadded {
  padding: 32px;
}</style>
